import styled from 'styled-components';
import { StyledWrapper } from '../styled';

export const StyledContainer = styled(StyledWrapper)`
  position: initial;
  @media screen and (max-width: 426px) {
    padding-top: 100px;
  }
`;
